import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { key: 2 };
const _hoisted_4 = { key: 0 };
const _hoisted_5 = { key: 3 };
const _hoisted_6 = { key: 2 };
const _hoisted_7 = { key: 3 };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AppAddress',
    props: {
        address: {},
        variant: {},
        countryDisplay: {}
    },
    setup(__props) {
        const props = __props;
        const variantOrDefault = computed(() => props.variant ?? "block");
        const countryDisplayOrDefault = computed(() => props.countryDisplay ?? "separate_line");
        const postalAddress = computed(() => props.address.hasOwnProperty('name1') ? props.address : null);
        const standardAddress = computed(() => !props.address.hasOwnProperty('name1') ? props.address : null);
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("address", null, [
                (postalAddress.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(_toDisplayString(postalAddress.value.name1) + _toDisplayString(postalAddress.value.name1 && variantOrDefault.value === 'inline' ? ', ' : '') + " ", 1),
                        (postalAddress.value.name1 && variantOrDefault.value === 'block')
                            ? (_openBlock(), _createElementBlock("br", _hoisted_1))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(postalAddress.value.name2) + _toDisplayString(postalAddress.value.name2 && variantOrDefault.value === 'inline' ? ', ' : '') + " ", 1),
                        (postalAddress.value.name2 && variantOrDefault.value === 'block')
                            ? (_openBlock(), _createElementBlock("br", _hoisted_2))
                            : _createCommentVNode("", true),
                        _createTextVNode(" " + _toDisplayString(postalAddress.value.name3) + _toDisplayString(postalAddress.value.name3 && variantOrDefault.value === 'inline' ? ', ' : '') + " ", 1),
                        (postalAddress.value.name3 && variantOrDefault.value === 'block')
                            ? (_openBlock(), _createElementBlock("br", _hoisted_3))
                            : _createCommentVNode("", true)
                    ], 64))
                    : _createCommentVNode("", true),
                _cache[1] || (_cache[1] = _createTextVNode()),
                (standardAddress.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(_toDisplayString(standardAddress.value.company) + _toDisplayString(standardAddress.value.company && variantOrDefault.value === 'inline' ? ', ' : '') + " ", 1),
                        (standardAddress.value.company && variantOrDefault.value === 'block')
                            ? (_openBlock(), _createElementBlock("br", _hoisted_4))
                            : _createCommentVNode("", true),
                        _cache[0] || (_cache[0] = _createTextVNode()),
                        (standardAddress.value.titleCode && standardAddress.value.titleCode !== 'unknown')
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                _createTextVNode(_toDisplayString(_ctx.$t('address.title.' + standardAddress.value.titleCode)), 1)
                            ], 64))
                            : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                                _createTextVNode(_toDisplayString(standardAddress.value.title), 1)
                            ], 64)),
                        _createTextVNode(" " + _toDisplayString(standardAddress.value.firstName) + " " + _toDisplayString(standardAddress.value.lastName) + _toDisplayString((standardAddress.value.firstName || standardAddress.value.lastName) && variantOrDefault.value === 'inline' ? ', ' : '') + " ", 1),
                        (((standardAddress.value.titleCode && standardAddress.value.titleCode !== 'unknown') || standardAddress.value.title || standardAddress.value.firstName || standardAddress.value.lastName) && variantOrDefault.value === 'block')
                            ? (_openBlock(), _createElementBlock("br", _hoisted_5))
                            : _createCommentVNode("", true)
                    ], 64))
                    : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(__props.address.street) + _toDisplayString(__props.address.street && variantOrDefault.value === 'inline' ? ', ' : '') + " ", 1),
                (__props.address.street && variantOrDefault.value === 'block')
                    ? (_openBlock(), _createElementBlock("br", _hoisted_6))
                    : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(__props.address.country && countryDisplayOrDefault.value === 'before_zip_code' ? (__props.address.country + '-') : '') + _toDisplayString(__props.address.zipCode) + " " + _toDisplayString(__props.address.city) + _toDisplayString((__props.address.zipCode || __props.address.city) && variantOrDefault.value === 'inline' ? ', ' : '') + " ", 1),
                ((__props.address.zipCode || __props.address.city) && variantOrDefault.value === 'block')
                    ? (_openBlock(), _createElementBlock("br", _hoisted_7))
                    : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(__props.address.country && countryDisplayOrDefault.value === 'separate_line' ? _ctx.$t('country.' + __props.address.country) : ''), 1)
            ]));
        };
    }
});
